import React from 'react';
import Modal from 'react-modal';
import FileExplorer from './FileExplorer';

const DOCKED_PANEL_WIDTH = 420;

const modalStyles = {
    content: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '95vw',
        maxWidth: '1000px',
        height: '85vh',
        maxHeight: '85vh',
        padding: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '10px',
        background: 'var(--bg-secondary)',
        border: '1px solid var(--border-primary)',
        color: 'var(--text-primary)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 4000,
    },
};

const mobileModalStyles = {
    content: {
        ...modalStyles.content,
        top: 0, left: 0, right: 0, bottom: 0,
        transform: 'none',
        width: '100vw', maxWidth: '100vw',
        height: '100vh', maxHeight: '100vh',
        borderRadius: 0, boxShadow: 'none', border: 'none',
    },
    overlay: modalStyles.overlay,
};

// Dock icon (panel-right layout)
const DockIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path d="M14 2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12zM2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2z"/>
        <path d="M10 3v10h4V3h-4z"/>
    </svg>
);

// Undock icon (pop-out / overlapping squares)
const UndockIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path d="M5.5 0a.5.5 0 0 1 .5.5v4A1.5 1.5 0 0 1 4.5 6h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5m5 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 10 4.5v-4a.5.5 0 0 1 .5-.5M.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5"/>
    </svg>
);

const FileExplorerPanel = ({
    isOpen,
    onClose,
    authUsername,
    attachedFiles,
    onAttachmentsChange,
    initialViewerPath,
    mode = 'modal',
    onToggleMode,
}) => {
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

    const header = (
        <div className="fe-modal-header">
            <h2 className="fe-modal-title">File Explorer</h2>
            <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                {!isMobile && onToggleMode && (
                    <button
                        onClick={onToggleMode}
                        className="fe-btn"
                        title={mode === 'docked' ? 'Undock to modal' : 'Dock to side panel'}
                    >
                        {mode === 'docked' ? <><UndockIcon /> Modal</> : <><DockIcon /> Sidebar</>}
                    </button>
                )}
                <button onClick={onClose} className="fe-modal-close" title="Close File Explorer">&times;</button>
            </div>
        </div>
    );

    const body = (
        <div className="fe-modal-body">
            <FileExplorer
                authUsername={authUsername}
                attachedFiles={attachedFiles}
                onAttachmentsChange={onAttachmentsChange}
                initialViewerPath={initialViewerPath}
            />
        </div>
    );

    // Docked mode: render as a plain div (no modal overlay)
    if (mode === 'docked' && isOpen && !isMobile) {
        return (
            <div className="fe-docked-panel" style={{ width: DOCKED_PANEL_WIDTH }}>
                {header}
                {body}
            </div>
        );
    }

    // Modal mode (or mobile always)
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={isMobile ? mobileModalStyles : modalStyles}
            contentLabel="File Explorer"
            ariaHideApp={false}
        >
            {header}
            {body}
        </Modal>
    );
};

export { DOCKED_PANEL_WIDTH };
export default FileExplorerPanel;
